import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { makeStyles } from '@material-ui/core/styles';

import TopButton from '../../../Components/UI/TopButtons';
import Confirmation from "../../../Components/Modal/Confirmation";

import StudentProgress from '../../../Components/ProgressBar/StudentProgress';
import LeaderBoardModal from '../../../Components/Modal/LeaderBoardModal';
import { getUsersByUuid, getTasksUuid, getAssignmentLearnersData, getAssignmentOverviewData } from "../Services";
import { joinByKeys, getClassNames } from "../../../Js/Common";
import { commonSliceActions } from "../../../Store/Slices/CommonSlice";

import { find } from "lodash";

const AssignmentStudentList = (props) => {
    // Hooks
    const styles = useStyles();
    const navigation = useNavigate();
    const dispatch = useDispatch();
    const wasCalled = useRef(false);
    const listInnerRef = useRef();

    const paginationVal = 10;

    // Redux stateis
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
    const { paramsdata } = useSelector((state) => state.common);

    //Parent State
    const [learnerIds, setLearnerIds] = useState([]);
    const [tasksIds, setTasksIds] = useState([]);
    const [selectedClasses, setSelectedClasses] = useState([]);    

    //State
    const [alertFlag, setAlertFlag] = useState(false);
    const [userData, setUserData] = useState([]);    
    const [skipData, setSkipData] = useState(0);
    const [limitData, setLimitData] = useState(paginationVal);

    const [totalUsers, setTotalUsers] = useState(0);
    const [totalAssets, setTotalAssets] = useState(0);
    const [isFetching, setIsFetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [leaderBoard, setLeaderBoard] = useState([]);
    const [classes, setClasses] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);

    // React logic hooks
    useEffect(() => {
        const getClasses = async () => {            
            setClasses(await getClassNames(userInfo.site_uuid));
        }
        getClasses()
    }, []);

    useEffect(() => {
        if (paramsdata !== null) {
            setLearnerIds(paramsdata.reportData.learners.learners);
            setTasksIds(paramsdata.reportData.tasks.tasks);
            setSelectedClasses(paramsdata.selectedClasses);
            setTotalUsers(paramsdata.reportData.learners.learners.length);

            if(paramsdata.selectedClass){                 
                 let newParams = { ...paramsdata, "selectedClass": null };
                dispatch(commonSliceActions.setParamsData(newParams));
            }            
        }
    }, [classes, paramsdata]);

    useEffect(() => {
        console.log("wasCalled.current", wasCalled.current);
        if (wasCalled.current) return;
        if (learnerIds.length > 0 && tasksIds.length > 0) {
            wasCalled.current = true;
            const getUsers = async () => {
                dispatch(commonSliceActions.setLoader(true));
                await fetchSelectedLearners();
            }
            getUsers();
        }
    }, [learnerIds, tasksIds]);

    useEffect(() => {
        const paginationRender = async () => {
            console.log("pagination");
            dispatch(commonSliceActions.setLoader(true));
            await fetchSelectedLearners();
        }
        if (isFetching) {
            paginationRender();
        }
    }, [isFetching]);

    const handleInfinityScroll = () => {
        console.log("OKKKK");
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            let totalHeight = Math.ceil(scrollTop + clientHeight);
            if (totalHeight >= scrollHeight || totalHeight == scrollHeight - 1 || totalHeight === scrollHeight) {
                return true;
            }
            return false;
        }
    };

    const handleLoadMore = () => {
        if(userData && +userData.length < +totalUsers){
            setIsLoading(true);
        }
        setTimeout(() => {
            if ((skipData / paginationVal) < (Math.ceil(totalUsers / paginationVal) - 1)) {
                setSkipData(() => limitData);
                setLimitData(() => limitData+paginationVal);
                setIsFetching(() => true);
            }
        }, 1000);
    };

    const fetchSelectedLearners = async () => {
        let totalAssetData;
        if (totalAssets == 0) {
            totalAssetData = await fetchTaskData();
            setTotalAssets(totalAssetData);
        } else {
            totalAssetData = totalAssets;
        }
        console.log("skipData",skipData, "limitData", limitData);
        let newArr = learnerIds.slice(skipData, limitData);         
        console.log("newArr=====>", newArr);

        await fetchUserData(newArr, totalAssetData, false)
    };

    const fetchUserData = async (selectedLearnerIds, totalAssetData, flag) => {
        let filterBelongsTo;
        if (selectedClasses.length > 0) {
            filterBelongsTo = selectedClasses;
        }

        let limitData;
        if(flag) {
            limitData = -1;
        }

        let params = {
            query: {
                $select: ['uid', 'name', 'belongs_to'],
                uid: selectedLearnerIds,
                site_uuid: paramsdata.reportData.site_uuid,
                belongs_to: filterBelongsTo,
                $limit: limitData
            }
        };
        
        let resUserData = await getUsersByUuid(params);
        // console.log("resUserData.response", resUserData.response);
        setIsFetching(false);
        setIsLoading(false);
        
        let resultData = [];
        if (resUserData.response.data) {
            resultData = resUserData.response.data;
        } else {
            resultData = resUserData.response;
        }
        return await fetchAssignmentLearnersData(selectedLearnerIds, resultData, totalAssetData, flag)
    };

    const fetchAssignmentLearnersData = async (selectedLearnerIds, resUsersData, totalAssetData, flag) => {
        let params = {
            uid: paramsdata.reportData.uid,
            learners: selectedLearnerIds,
            site_uuid: paramsdata.reportData.site_uuid
        };
        let resLearnersData = await getAssignmentLearnersData(params);
        let totalAssets = totalAssetData;

        resUsersData.map((data) => {
            data.totalAssets = totalAssets;
            if (resLearnersData.response.length > 0) {
                let scoreInfo = find(resLearnersData.response, { actor: data.uid });
                if (scoreInfo) {
                    data.genericscore = scoreInfo.genericscore;
                    data.attemptedassets = scoreInfo.attemptedassets;
                    data.attempted_assets_ids = scoreInfo.attempted_assets_ids;
                    data.rank = scoreInfo.rank ? scoreInfo.rank : 0;
                } else {
                    data.genericscore = 0;
                    data.attemptedassets = 0;
                    data.attempted_assets_ids = [];
                    data.rank = 0;
                }
            } else {
                data.genericscore = 0;
                data.attemptedassets = 0;
                data.attempted_assets_ids = [];
                data.rank = 0;
            }

            //csv when download with status
            if (Number(data.attemptedassets) == 0) {
                data.status = 'Not Attempted';
            } else if (Number(data.attemptedassets) < Number(totalAssets) && Number(data.attemptedassets) > 0) {
                data.status = 'Pending';
            } else if (Number(totalAssets) == Number(data.attemptedassets) || Number(totalAssets) < Number(data.attemptedassets)) {
                data.status = 'Completed';
            }
            data.percentage = (data.genericscore / data.totalAssets * 100).toFixed(2);
        });
        if (flag) {
            resUsersData.sort((a, b) => b.percentage - a.percentage);
            setLeaderBoard(resUsersData);
            return resUsersData;
        } else {
            setUserData(prevData => [...prevData, ...resUsersData]);
        }
        dispatch(commonSliceActions.setLoader(false));
    };

    const fetchTaskData = async () => {
        let params = {
            query: {
                $select: ['data1', 'tasktype'],
                uid: tasksIds,
                site_uuid: paramsdata.reportData.site_uuid
            }
        };
        let resTaskData = await getTasksUuid(params);

        let totalAssets = 0;
        resTaskData.data.forEach(element => {
            let assets;
            let tasktype = element.tasktype;
            if (tasktype == 'assets' || tasktype == 'library') {
                assets = element.data1.exersices;
            } else {
                assets = element.data1.media;
            }
            totalAssets = totalAssets + assets.length;
        });
        return totalAssets;
    };

    const handleLearderBoard = async () => {
        setModalVisible(true);
        //dispatch(commonSliceActions.setLoader(true));
        if (leaderBoard.length <= 0) {
            await fetchUserData(learnerIds, totalAssets, true);
        }
    };

    const handleHeatmap = () => {
        navigation('/Report/HeatmapList');
    };

    const handleSkillWise = () => {
        navigation('/Report/AssignmentWiseSkills');
    };

    // Set class list
    const filterClass = (classId) => {
        let findObj = classes.find((obj) => {
            return obj.id == classId
        });
        return findObj.value || '';
    };

    //Download Csv
    const handleDownloadCsv = async () => {

        if (userData.length > 0) {
            let csv = '';
            csv = 'Student Name, Class, Total Assets, Attempted Assets, Percentage, Status\n';

            userData.forEach((element) => {
                let name = joinByKeys(element.name, ['firstname', 'lastname'], ' ')
                let className = filterClass(element.belongs_to);
                csv = csv + name + "," + className + "," + element.totalAssets + "," + element.attemptedassets + "," + element.percentage + "," + element.status;
                csv += '\n';
            });

            let hiddenElement = document.createElement('a');
            hiddenElement.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
            // hiddenElement.setAttribute('download', 'learner.csv');
            hiddenElement.setAttribute('download', paramsdata.reportData.title.split(" ").join("_") + '_assignment_overview.csv');
            document.body.appendChild(hiddenElement);
            hiddenElement.click();
            document.body.removeChild(hiddenElement);
        } else {
            alert('User data not available!');
        }
    };

    const redirectTo = (learnerData) => {
        if (Number(learnerData.attemptedassets) == 0) {
            setAlertFlag(true);
        } else {
            let newParams = { ...paramsdata, "learnerData": learnerData };
            dispatch(commonSliceActions.setParamsData(newParams));
            navigation("/Report/LearnerAssetList");
        }
    };

    return (
        <>
            <TopButton
                title={(paramsdata) ? paramsdata.reportData.title : ''}
                secondaryText= {userData.length > 0 ? `${userData.length}/${totalUsers}` : ``}
                centerText={isLoading ? `Loading...` : ``}
                textTitleBtn={"Leader Board"}
                pressTitleBtn={() => { handleLearderBoard() }}
                downloadIcon={true}
                pressTopBtn={() => { handleDownloadCsv() }}
                buttonText={'Heatmap'}
                press={() => { handleHeatmap() }}
                buttonText1={'SkillWise'}
                press1={() => { handleSkillWise() }}
            >
            </TopButton>

            <Grid container>
                <Grid
                    xs={12}
                    sx={{ flexDirection: 'row', justifyContent: 'flex-start', mt: 1, pl: 7 }}>
                    <Grid item
                        sx={{ border: 1, borderColor: '#EAECEE', borderRadius: 8, mx: 10 }}>
                        <Box
                            onScroll={() => {
                                if (handleInfinityScroll()) {
                                    handleLoadMore();
                                }
                            }}                            
                            ref={listInnerRef}
                            className={styles.scrollBar}
                            sx={{ pl: 4, pr: 4, py: 2, height: '68vh', overflow: isLoading ? 'hidden' : 'auto', mb: 1, mr: 2 }}
                        >
                            {userData && userData.map((data, index) => {
                                return (
                                    <StudentProgress
                                        key={`learner_report_${index}`}
                                        data={data}
                                        classes={classes}
                                        index={index}
                                        isScoreDisplay={true}
                                        redirectTo={() => { redirectTo(data) }}
                                    />
                                )
                            })}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Confirmation
                image="error"
                primaryText="Not attempted!"
                visible={alertFlag}
                toggleModal={(flag) => setAlertFlag(flag)}
                alert={true}
                timeout={2200}
            />
            <LeaderBoardModal
                show={modalVisible}
                toggleModal={(flag) => setModalVisible(flag)}
                leaderBoardData={leaderBoard}
                classes={classes}
                persistent={false}
            />
        </>
    )
};
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
});
export default AssignmentStudentList;